import { CellProps } from 'react-table'
import { TFunction } from '../../../../../../../_metronic/i18n/Metronici18n'
import {
  DataColumn,
  PlainHeader,
  StackedCell,
  StatusDot,
  TableColumn,
} from '../../../../../../components'
import { NotaVersaoUsuarioItem } from '../../../core/_models'
import { NovidadesActionsCell } from './NovidadesActionsCell'

export const novidadesColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<NotaVersaoUsuarioItem>> => [
  {
    Header: () => <PlainHeader>{t('notas_versao.col.nota')}</PlainHeader>,
    id: 'titulo',
    Cell: ({ row }: CellProps<NotaVersaoUsuarioItem>) => (
      <StackedCell
        primary={row.original.titulo}
        secondary={t('notas_versao.versao_x', { versao: row.original.versao })}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('notas_versao.col.publicacao')}</PlainHeader>,
    id: 'dtPublicacao',
    cellWidth: '160px',
    Cell: ({ row }: CellProps<NotaVersaoUsuarioItem>) => (
      <DataColumn data={row.original.dtPublicacao} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('notas_versao.col.leitura')}</PlainHeader>,
    id: 'situacao',
    cellWidth: '130px',
    Cell: ({ row }: CellProps<NotaVersaoUsuarioItem>) => (
      <StatusDot
        label={t(`notas_versao.leitura.${row.original.situacao}`)}
        tone={row.original.situacao === 'LIDA' ? 'neutral' : 'primary'}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<NotaVersaoUsuarioItem>) => (
      <NovidadesActionsCell nota={row.original} />
    ),
  },
]
